import { MultiMaterialCompositeDto } from './multi-material-composite-dto';
import { ChangeCandidateDto } from '../change-candidate-dto';

export class ChangeMaterialCandidateDto extends ChangeCandidateDto {
    updatedMultiMaterial!: MultiMaterialCompositeDto;
    existingMultiMaterial!: MultiMaterialCompositeDto;
}
